import React from 'react';
import styles from './styles';
import { Title, Description } from './constants';

const AppointmentBookingPlaceholder = () => {
  return (
    <div style={styles.container}>
      <i className="icon icon-calendar" style={styles.icon} />
      <p style={styles.title}>{Title}</p>
      <p style={styles.description}>{Description}</p>
    </div>
  );
}

export default AppointmentBookingPlaceholder;
